import React from "react";
import Home from "./Home/Home";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import CartSummary from "./Cart/CartSummary";
import CategoryPage from "./Category/CategoryPage";
import ProductDetailPage from "./Product/ProductDetailPage";

function App() {
  // return <Home />;

  return (<BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/category/:slug" element={<CategoryPage />} />
        <Route path="/product/:id" element={<ProductDetailPage />} />
        <Route path="/cart-summary" element={<CartSummary />} />
      </Routes>
    </BrowserRouter>);
}

export default App;